export const updateSlotsParamForMapTravelAds = (url: string): string => url.replace(RegExp('(slots=)[^&]+'), '$1HSR_Map');
